import { ENTITY_TYPE }       from '@core/interfaces/entity.interface';
import {
	AdapterState,
	Selector,
	SelectorWithProps
}                            from '@core/interfaces/store.interface';
import { IPropsEntityId }    from '@core/store/adapter/adapter.actions';
import { IAdapterSelectors } from '@core/store/adapter/adapter.selectors';
import { EntityAdapter }     from '@ngrx/entity';
import { createSelector }    from '@ngrx/store';

// TODO test if selector interface is working and create for other selectors as well if yes
export interface IApiSelectors<S extends AdapterState<T>, T> {
	list: Selector<S, T[]>;
	read: SelectorWithProps<S, IPropsEntityId<T>, T>;
}


export function apiSelectors<T, S extends AdapterState<T>>(
	adapter: EntityAdapter<T>,
	adapterSelectors: IAdapterSelectors<T>
) {

	return {
		list: createSelector(
			adapterSelectors.all,
			( entities: T[] ) => entities
		),

		listByIds: ( ids: string[] ) => createSelector(
			adapterSelectors.all,
			( entities: T[] ) => {
				return entities?.length
							 ? entities?.filter( ( storeEntity: T ) => {
						const entity = storeEntity as ENTITY_TYPE;

						if ( entity.hasOwnProperty( 'id' ) ) {
							return ids.includes( entity?.id )
										 ? entity
										 : null;
						}
						return null;
					} )
							 : null;
			}
		),

		read: ( entityId: string ) => createSelector(
			adapterSelectors.all,
			( entities: T[] ) =>
				entities?.length
				? entities?.find( ( storeEntity: T ) => {
					const entity = storeEntity as ENTITY_TYPE;
					return entity.id === entityId;
				} )
				: null
		)
	};
}
